import {
    USER_CLEAR_REQUISITES,
    USER_FETCH_MODEL,
    USER_PREFERENCES_WAS_UPDATED,
    USER_SET_ACCESS_TOKEN,
    USER_SET_PREFERENCES,
    USER_SET_USER_MODEL,
    USER_UPDATE_PREFERENCE
} from './constants';
import {IReduxUserState} from '../../@interfaces';

export const setAccessToken = (token: string) => ({type: USER_SET_ACCESS_TOKEN, payload: token});
export const setUserModel = (user: any) => ({type: USER_SET_USER_MODEL, payload: user});
export const clearUserRequisites = () => ({type: USER_CLEAR_REQUISITES});
export const userPreferencesWasUpdated = () => ({type: USER_PREFERENCES_WAS_UPDATED});
export const setPreferences = (list: IReduxUserState['preferences']) => ({type: USER_SET_PREFERENCES, payload: list});
export const updatePreference = (key: string, value: any) => ({type: USER_UPDATE_PREFERENCE, payload: {key, value}});

export const fetchUserModel = () => ({type: USER_FETCH_MODEL});
